//mypreset.ts
import { definePreset } from '@openng/optimus-ui-themes'
import Aura from '@openng/optimus-ui-themes/aura'

const MyPreset = definePreset(Aura, {
	semantic: {
		colorScheme: {
			light: {
				primary: {
					color: '#8D54D5',
					hoverColor: '#C4B5FD',
					activeColor: '#4E1284',
				},

				surface: {
					ground: '#FAF5FF',
					section: '#FCFAFE',
					card: '#FFFFFF',
				},

				content: {
					background: '#FCFAFE',
					hoverBackground: '#F3E8FF',
					borderColor: '#E9D5FF',
				},
			},

			dark: {
				primary: {
					color: '#A78BFA',
					hoverColor: '#C4B5FD',
					activeColor: '#4E1284',
				},

				surface: {
					ground: '#1A1025',
					section: '#231533',
					card: '#2D1B40',
				},

				content: {
					background: '#2D1B40',
					hoverBackground: '#3B2555',
					borderColor: '#4C3470',
				},
			},
		},
	},
})

export default MyPreset
